import React, { useState } from 'react';
import reportWebVitals from './reportWebVitals';

export default function App() {
	const questions = [
		{
			questionText: 'What is the capital of England?',
			questionImage: 'https://media.ticmate.com//resources/ticmate_live/upload_go/9e062c852a50939e-LondonEyeMobile4.jpg',
			answerOptions: [
				{ answerText: 'New York', isCorrect: false },
				{ answerText: 'London', isCorrect: true },
				{ answerText: 'Paris', isCorrect: false },
				{ answerText: 'Dublin', isCorrect: false },
			],
		},
		{
			questionText: 'What is the name of the Queen?',
			questionImage: 'https://britishheritage.com/uploads/article/2019/7/1905/article_Cricket_Queen.jpg?t=1563277262',
			answerOptions: [
				{ answerText: 'Elizabeth II', isCorrect: true },
				{ answerText: 'Margaret IV', isCorrect: false },
				{ answerText: 'Rapunzel', isCorrect: false },
				{ answerText: 'Tony Stark', isCorrect: false },
			],
		},
		{
			questionText: 'Where was Shakespeare born?',
			questionImage: 'https://d15-a.sdn.cz/d_15/c_img_gT_a/OVLBod.jpeg?fl=cro,0,106,1250,703%7Cres,1200,,1%7Cwebp,75',
			answerOptions: [
				{ answerText: 'Prague', isCorrect: false },
				{ answerText: 'London', isCorrect: false },
				{ answerText: 'Stratford-upon-Avon', isCorrect: true },
				{ answerText: 'Manchaster', isCorrect: false },
			],
		},
		{
			questionText: 'How many Harry Potter books are there?',
			questionImage: 'https://ichef.bbci.co.uk/news/976/cpsprodpb/17935/production/_106256569_hpotterbookgetty.jpg',
			answerOptions: [
				{ answerText: '1', isCorrect: false },
				{ answerText: '4', isCorrect: false },
				{ answerText: '6', isCorrect: false },
				{ answerText: '7', isCorrect: true },
			],
		},
		{
			questionText: 'What is the national animal of England?',
			questionImage: 'https://maketimetoseetheworld.com/wp-content/uploads/2020/04/African-Animals-Big-5-Africa.jpg',
			answerOptions: [
				{ answerText: 'Tiger', isCorrect: false },
				{ answerText: 'Cat', isCorrect: false },
				{ answerText: 'Cheetah', isCorrect: false },
				{ answerText: 'Lion', isCorrect: true },
			],
		}
	];

	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [showScore, setShowScore] = useState(false);
	const [score, setScore] = useState(0);
	const [userAnswer, setUserAnswer] =useState([]);

	const handleAnswerOptionClick = (isCorrect, answerText) => {
		if (isCorrect) {
			const userAnswers = answerText;
			setUserAnswer([...userAnswer, userAnswers]);
			setScore(score + 1);
			//console.log(userAnswers);
		}
		else{
			const userAnswers = answerText;
			setUserAnswer([...userAnswer, userAnswers]);
			//console.log(answerText);
		}
		
		const nextQuestion = currentQuestion + 1;
		if (nextQuestion < questions.length) {
			setCurrentQuestion(nextQuestion);
		} else {
			setShowScore(true);
			//console.log(questions[0].answerOptions.find(x => x.isCorrect === true).answerText)
		}		
	};

	const handleBackToQuiz = () => {
		setCurrentQuestion(0);
		setScore(0);
		setShowScore(false);
		setUserAnswer([]);

		//console.log('Byl jsem zakliknut')
	}
	return (
		<div>
			{showScore ? (
				<>
					<div className='score-text'>You scored {score} out of {questions.length}</div>
					<div className='correct-answer-section'>
						<div className='correct-answer-question-text'>Correct Answers:</div>
						<div className='correct-answer-question-text'>1. {questions[0].questionText}</div>
							<div className='correct-answer-text'>- {questions[0].answerOptions.find(x => x.isCorrect === true).answerText}</div>
						<div className='correct-answer-question-text'>2. {questions[1].questionText}</div>
							<div className='correct-answer-text'>- {questions[1].answerOptions.find(x => x.isCorrect === true).answerText}</div>
						<div className='correct-answer-question-text'>3. {questions[2].questionText}</div>
							<div className='correct-answer-text'>- {questions[2].answerOptions.find(x => x.isCorrect === true).answerText}</div>
						<div className='correct-answer-question-text'>4. {questions[3].questionText}</div>
							<div className='correct-answer-text'>- {questions[3].answerOptions.find(x => x.isCorrect === true).answerText}</div>
						<div className='correct-answer-question-text'>5. {questions[4].questionText}</div>
							<div className='correct-answer-text'>- {questions[4].answerOptions.find(x => x.isCorrect === true).answerText}</div>
					</div>
					<div className='user-answer-section'>
						<div className='correct-answer-question-text'>Your Answers:</div>
						<div className='correct-answer-question-text'>1. {questions[0].questionText}</div>
							<div className='correct-answer-text'>- {userAnswer[0]}</div>
						<div className='correct-answer-question-text'>2. {questions[1].questionText}</div>
							<div className='correct-answer-text'>- {userAnswer[1]}</div>
						<div className='correct-answer-question-text'>3. {questions[2].questionText}</div>
							<div className='correct-answer-text'>- {userAnswer[2]}</div>
						<div className='correct-answer-question-text'>4. {questions[3].questionText}</div>
							<div className='correct-answer-text'>- {userAnswer[3]}</div>
						<div className='correct-answer-question-text'>5. {questions[4].questionText}</div>
							<div className='correct-answer-text'>- {userAnswer[4]}</div>
					</div>
					<div className='back-to-quiz'>
						<button className='back-to-quiz-text' onClick={() => handleBackToQuiz()}>Try again</button>
					</div>
				</>
			) : (
				<>
					<div  className='whole-app'>
						<div className='app'>
							<div className='question-section'>
								<div className='question-count'>
									<span>Question {currentQuestion + 1}/{questions.length}</span>
								</div>
								<div className='question-text'>{questions[currentQuestion].questionText}</div>
								<img src={questions[currentQuestion].questionImage} className='question-image' alt=''></img>
							</div>
							<div className='answer-section'>
								{questions[currentQuestion].answerOptions.map((answerOption) => (
									<button className='answer-text'onClick={() => handleAnswerOptionClick(answerOption.isCorrect, answerOption.answerText)}>{answerOption.answerText}</button>
								))}
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	);
}

